import {MithrilComponent} from '@bitstillery/mithril'
import {unique_id} from '@bitstillery/common/lib/utils'
import {FieldText} from '@bitstillery/common/components/fields/text/text'
import {Button} from '@bitstillery/common/components/ui/button/button'
import m from '@bitstillery/mithril'

import type {ModelRef} from '@bitstillery/common/types/field'
import type {Validator} from '@bitstillery/common/lib/validation'

interface FieldListInputAttrs {
    items: [string] | string[]
    model: ModelRef
    validation: {new_item?: Validator}
    disabled?: boolean
    label: string
    placeholder: string
    onadd: () => void
    ondelete: (item: string) => void
}

export class FieldListInput extends MithrilComponent<FieldListInputAttrs> {
    id = unique_id()

    view(vnode: m.Vnode<FieldListInputAttrs>) {
        const {disabled, model, items, validation} = vnode.attrs
        return (
            <div className='c-list-input' id={this.id}>
                <div className='field-group list-input'>
                    <FieldText label={vnode.attrs.label} placeholder={vnode.attrs.placeholder} model={model}>
                        <Button
                            disabled={disabled || Boolean(validation['new_item']?._invalid)}
                            icon='plus'
                            onclick={vnode.attrs.onadd}
                        />
                    </FieldText>
                </div>
                <div className='unit-list'>
                    {items.map((item) => (
                        <div className='list-item'>
                            <span className='content'>{item}</span>
                            <Button
                                icon='trash'
                                type='danger'
                                disabled={disabled}
                                onclick={() => {
                                    vnode.attrs.ondelete(item)
                                }}
                            />
                        </div>
                    ))}
                </div>
            </div>
        )
    }
}
